import { getProductStockAvailable } from "../libs/productSizes";

const QuickAddSizeModal = ({ pending, onConfirm, onCancel }) => {
  if (!pending) return null;

  const { product, sizes, sizeFields } = pending;

  return (
    <div className="quick-add-size-overlay" role="dialog" aria-modal="true" aria-labelledby="quick-add-size-title">
      <div className="quick-add-size-card">
        <h3 id="quick-add-size-title">Select size</h3>
        <p className="quick-add-size-product">{product.name}</p>
        <div className="quick-add-size-options">
          {sizes.map((size) => (
            <button
              key={size.field}
              type="button"
              className="quick-add-size-option"
              onClick={() => onConfirm(size.label)}
            >
              <span>{size.label}</span>
              <small>{getProductStockAvailable(product, size.label, sizeFields)} left</small>
            </button>
          ))}
        </div>
        <button type="button" className="quick-add-size-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default QuickAddSizeModal;
